/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLocation, useNavigate } from 'react-router-dom';
import { Footer } from '../components';
import { NextIcon, PrevIcon } from '../components/Blogs/BlogIcons';
import BlogCard, { extractDateTime } from '../components/Blogs/BlogCard';
import Loading from '../../components/common/Loading';
import { useBlogs } from '../../components/context/BlogContext';
import { useEffect, useState } from 'react';
import GlobalHeader from '../../components/GlobalHeader';
import { format } from 'date-fns';


const BlogDetails = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { index } = location.state ?? { index: 0 };
  const { blogs, isLoading, hasMore, loadMore } = useBlogs();
  const [currentIndex, setCurrentIndex] = useState<number>(index);
  const [blog, setBlog] = useState(blogs?.[index] || null);
  const { date } = extractDateTime(blog?.publishedAt ?? new Date().toISOString());

  function splitHeadingAndSubheading(input: string): { heading: string; subheading: string } {
    const separator = '-';
    const [heading, subheading] = typeof input === 'string' ? input.split(separator) : ['', ''];
    return {
      heading: heading?.trim() || '',
      subheading: subheading?.trim() || '',
    };
  }

  const { heading, subheading } = splitHeadingAndSubheading(blog?.heading);

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
      navigate(`/blog/${blogs?.[currentIndex - 1] ? blogs?.[currentIndex - 1]?.slug : '/saagas'}`, { state: { index: currentIndex - 1 } });
    }
  };

  const handleNext = () => {
    if (currentIndex < blogs.length - 1) {
      setCurrentIndex((prev) => prev + 1);
      navigate(`/blog/${blogs?.[currentIndex + 1] ? blogs?.[currentIndex + 1]?.slug : '/saagas'}`, { state: { index: currentIndex + 1 } });
    } else if (hasMore) {
      loadMore();
    }
  };

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }, [location.pathname]);

  useEffect(() => {
    if (!location.state || !blog) {
      navigate('/blog');
    }
  }, [location.state, navigate, blog]);

  useEffect(() => {
    const newIndex = location.state?.index ?? 0;
    setCurrentIndex(newIndex);
    setBlog(blogs?.[newIndex] || null);
  }, [location.pathname, blogs, location.state?.index]);

  useEffect(() => {
    setBlog(blogs?.[currentIndex] || null);
  }, [currentIndex, blogs]);

  if (isLoading) return <Loading />;

  return (
    <>
      <div className='min-h-full'>
        <GlobalHeader />

        <div className='flex flex-col justify-center items-center font-inter'>
          <div className="bg-black px-6 md:px-12 text-white py-12 md:mx-14  max-w-[1088px] ">

            <div className='flex flex-col gap-[34px]'>

              <h1 className="text-[38px]  md:text-[46px]  font-[700]  leading-[100%] tracking-[0px] align-middle">
                {heading}
              </h1>

              <p className="text-[36px] font-[600] leading-none tracking-normal align-middle">
                {subheading}
              </p>

              <div className="profile flex items-center gap-2 mt-4 mb-8 text-[16px] leading-[24px] tracking-[0px]  font-normal align-middle">
                <img
                  src="/icon.ico"
                  className="w-8 h-8 rounded-full object-cover"
                  alt="Profile of Yolando"
                />

                <p>Yolando</p>
                <div className="w-1 h-1 rounded-full bg-white" />

                <p className="font-medium">
                  {format(new Date(date), 'MMMM d, yyyy')}
                </p>
              </div>

            </div>

            <img
              className="w-[1088px] h-[309px] rounded-[12px] object-cover mb-10"
              src={blog?.Image ? blog?.Image?.url : '/backdrop.jpg'}
              alt="A scenic view of a bird flying over a lake"
            />

            <div className="description  tracking-normal leading-relaxed">
              {blog?.blogDescription?.map(({ title, description }, index) => (
                <div key={index}>
                  {!title ? <>
                    <p className=" font-normal text-[20px] leading-[30px] tracking-[-0.26px] my-[16px]">
                      {description}
                    </p>
                  </> : <div className=''>
                    <h2 className=" font-[400] text-[32px] leading-[36px] tracking-[0px] align-middle my-[32px]">
                      {title}
                    </h2>

                    {description.map((e) => {
                      return <>
                        <p className=" font-normal text-[20px] leading-[30px] tracking-[-0.26px] my-[18px]">
                          {e}
                        </p>
                      </>;
                    })}

                  </div>}

                </div>
              ))}
            </div>

            {blog?.tags?.length > 0 && (
              <div className="flex flex-wrap items-center mt-12 text-white tracking-wide gap-[8px]">
                {blog.tags.map((tag) => (
                  <span
                    key={tag}
                    className="bg-[#393939] font-[400] text-sm px-4 py-2 rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}

            <div className="flex justify-between items-center mt-12 w-full">
              <button
                className={`flex items-center gap-2 bg-[#18181B] text-white px-4 py-2 rounded-md transition-all duration-200 ${currentIndex === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#2a2a2d]'
                  }`}
                onClick={handlePrevious}
                disabled={currentIndex === 0}
              >
                <NextIcon />
                <span className="flex gap-1 w-fit min-w-[104.28px]">Previous<span className='hidden md:flex'>Article</span> </span>
              </button>

              <button
                className={`flex items-center gap-2 bg-[#18181B] text-white px-4 py-2 rounded-md transition-all duration-200 ${currentIndex >= blogs?.length - 1 && !hasMore
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:bg-[#2a2a2d]'
                  }`}
                onClick={handleNext}
                disabled={currentIndex >= blogs?.length - 1 && !hasMore}
              >
                <span className="flex gap-1 w-fit min-w-[104.28px]">&nbsp;&nbsp;&nbsp;&nbsp;Next<span className='hidden md:flex'>Article</span></span>
                <PrevIcon />
              </button>
            </div>

            {isLoading && <Loading />}


            {blogs.length > 1 && (
              <div className="cards mt-20">
                <h2 className="text-2xl font-semibold mb-8 tracking-wider">You May Also Like</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-9">
                  {blogs
                    .filter((item) => item.id !== blog?.id)
                    .sort(() => Math.random() - 0.5)
                    .map((item, i) => {
                      const blogIndex = blogs?.findIndex((b) => b?.id === item?.id);
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            navigate(
                              `/blog/${blogs?.[blogIndex] ? blogs?.[blogIndex]?.slug : '/saagas'}`,
                              { state: { index: blogIndex } }
                            );
                          }}
                          className="cursor-pointer transition-transform hover:scale-[1.02]"
                        >
                          <BlogCard blog={item} index={blogIndex} />
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
      <Footer />
    </>


  );
};

export default BlogDetails;
